var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-xs-12 col-md-5" }, [
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card__content" }, [
            _c(
              "div",
              { staticClass: "form-field" },
              [
                _c(
                  "input-field",
                  {
                    attrs: { id: "codigo", readonly: _vm.modEditar },
                    model: {
                      value: _vm.form.codigo,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "codigo", $$v)
                      },
                      expression: "form.codigo"
                    }
                  },
                  [_vm._v("Código:")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-field" },
              [
                _c(
                  "input-field",
                  {
                    attrs: { id: "descripcion" },
                    model: {
                      value: _vm.form.descripcion,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "descripcion", $$v)
                      },
                      expression: "form.descripcion"
                    }
                  },
                  [_vm._v("Descripción:")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c(
                "div",
                { staticClass: "select2-field select2-field--stretch" },
                [
                  _c("v-select", {
                    attrs: {
                      id: "selectedMultipleUsuarios",
                      label: "nombre",
                      options: _vm.usuarios,
                      multiple: ""
                    },
                    on: { input: _vm.inputSelectedMultiple },
                    model: {
                      value: _vm.form.usuarios,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "usuarios", $$v)
                      },
                      expression: "form.usuarios"
                    }
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "selectedMultipleUsuarios" } }, [
                    _vm._v("Usuarios:")
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c("label", { attrs: { for: "todosUsuarios" } }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.todosUsuarios,
                      expression: "form.todosUsuarios"
                    }
                  ],
                  attrs: {
                    type: "checkbox",
                    id: "todosUsuarios",
                    name: "todosUsuarios"
                  },
                  domProps: {
                    checked: Array.isArray(_vm.form.todosUsuarios)
                      ? _vm._i(_vm.form.todosUsuarios, null) > -1
                      : _vm.form.todosUsuarios
                  },
                  on: {
                    change: [
                      function($event) {
                        var $$a = _vm.form.todosUsuarios,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.form,
                                "todosUsuarios",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.form,
                                "todosUsuarios",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.form, "todosUsuarios", $$c)
                        }
                      },
                      _vm.changeTodosSelectedMultiple
                    ]
                  }
                }),
                _vm._v(" "),
                _c("span", [_vm._v("Todos")])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group mb-2" }, [
              _c(
                "div",
                { staticClass: "select2-field select2-field--stretch" },
                [
                  _c("v-select", {
                    attrs: {
                      id: "SelectedTipoReporte",
                      label: "descripcion",
                      options: _vm.tipos
                    },
                    on: { input: _vm.inputSelectedTipoReporte },
                    model: {
                      value: _vm.selectedTipoReporte,
                      callback: function($$v) {
                        _vm.selectedTipoReporte = $$v
                      },
                      expression: "selectedTipoReporte"
                    }
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "SelectedTipoReporte" } }, [
                    _vm._v("Tipo reporte:")
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c("label", { attrs: { for: "todosTipo" } }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.todos_tipo_reporte,
                      expression: "form.todos_tipo_reporte"
                    }
                  ],
                  attrs: {
                    type: "checkbox",
                    id: "todosTipo",
                    name: "todosTipo"
                  },
                  domProps: {
                    checked: Array.isArray(_vm.form.todos_tipo_reporte)
                      ? _vm._i(_vm.form.todos_tipo_reporte, null) > -1
                      : _vm.form.todos_tipo_reporte
                  },
                  on: {
                    change: [
                      function($event) {
                        var $$a = _vm.form.todos_tipo_reporte,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.form,
                                "todos_tipo_reporte",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.form,
                                "todos_tipo_reporte",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.form, "todos_tipo_reporte", $$c)
                        }
                      },
                      _vm.changeTodosTipo
                    ]
                  }
                }),
                _vm._v(" "),
                _c("span", [_vm._v("Todos")])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.puede_crear || _vm.puede_editar,
                      expression: "puede_crear || puede_editar"
                    }
                  ],
                  staticClass: "btn-success",
                  attrs: { type: "submit" },
                  on: { click: _vm.guardar }
                },
                [
                  _c("i", { staticClass: "fa fa-save" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Guardar")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn-info ml-2",
                  attrs: { type: "submit" },
                  on: { click: _vm.nuevo }
                },
                [
                  _c("i", { staticClass: "fa fa-plus" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Nuevo")])
                ]
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("details", { staticClass: "card card--collapsible" }, [
          _vm._m(1),
          _vm._v(" "),
          _c("div", { staticClass: "card__content" }, [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                {
                  staticClass: "col-xs-12",
                  staticStyle: { height: "350px", "overflow-y": "scroll" }
                },
                [
                  _c("checked-listbox", {
                    attrs: {
                      items: _vm.campos,
                      columns: 2,
                      name: "campos[]",
                      field: "nombre"
                    },
                    on: { input: _vm.inputColumna },
                    model: {
                      value: _vm.form.columnas,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "columnas", $$v)
                      },
                      expression: "form.columnas"
                    }
                  })
                ],
                1
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-7" }, [
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card__content" }, [
            _c(
              "div",
              { staticClass: "table-responsive mt-3" },
              [
                _c("k-table", {
                  ref: "consultarPlantillas",
                  attrs: {
                    buttons: [
                      {
                        class: "btn-info",
                        icon: "fa-edit",
                        event: "editar"
                      },
                      {
                        class: "btn-danger",
                        icon: "fa-trash",
                        event: "eliminar"
                      }
                    ],
                    noForms: "",
                    params: _vm.datos,
                    mostrarTodos: false,
                    columns: _vm.columns,
                    path: _vm.path,
                    deleteButton: false,
                    createButton: false,
                    editButton: false
                  },
                  on: { eliminar: _vm.eliminar, editar: _vm.editar }
                })
              ],
              1
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__header" }, [
      _c("div", { staticClass: "layout__title" }, [
        _c("h3", [_vm._v("Plantillas")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "summary",
      { staticClass: "card__title card__title--bg-primary" },
      [
        _c("div", { staticClass: "form-inline" }, [
          _c("i", {
            staticClass: "fa fa-info-circle",
            attrs: { "aria-hidden": "true" }
          }),
          _vm._v(" "),
          _c("h5", [_vm._v("Campos")])
        ])
      ]
    )
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c9a5d6ca", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c9a5d6ca","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/plantillas/Plantilla.vue
// module id = 445
// module chunks = 0